"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const CheckIcon = () => (
  <Box
    sx={{
      width: 22,
      height: 22,
      borderRadius: "17%",
      bgcolor: "#F1ECFA",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    }}
  >
    <svg width="12" height="14" viewBox="0 0 12 12" fill="none">
      <path
        d="M10 3L4.5 8.5L2 6"
        stroke="#7A2BF5"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Box>
);

const ZaynCapabilitiesSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const capabilities = t("zaynCapabilities.items", { returnObjects: true }) || [];

  return (
    <Box
      sx={{
        py: { xs: 5, sm: 6, md: 8 },
        direction: isArabic ? "rtl" : "ltr",
        backgroundColor:'#F7F4FD'
      }}
    >
      <Container maxWidth="lg">
        <Typography
          sx={{
            fontSize: { xs: "11px", sm: "12px" },
            fontWeight: 600,
            color: "#7A2BF5",
            textTransform: "uppercase",
            letterSpacing: "1px",
            fontFamily: "var(--font-outfit)",
            textAlign: "center",
            mb: { xs: 1.5, sm: 2 },
          }}
        >
          {t("zaynCapabilities.label")}
        </Typography>

        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "22px", sm: "26px", md: "30px" },
            fontWeight: 700,
            lineHeight: 1.3,
            color: "#14122B",
            fontFamily: "var(--font-plusjakarta)",
            textAlign: "center",
            mb: { xs: 4, sm: 5 },
          }}
        >
          {t("zaynCapabilities.title")}
        </Typography>

        {/* 6 capability cards */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
            gap: { xs: 2, sm: 2.5 },
            mb: { xs: 4, sm: 5, md: 6 },
          }}
        >
          {capabilities.map((item, index) => (
            <Box
              key={index}
              sx={{
                bgcolor: "#FFFFFF",
                border: "1px solid #EDEDF2",
                borderRadius: "14px",
                p: { xs: 2.2, sm: 2.9 },
                textAlign: isArabic ? "right" : "left",
              }}
            >
              <Box sx={{ mb: { xs: 1.5, sm: 2 } }}>
                <CheckIcon />
              </Box>
              <Typography
                sx={{
                  fontSize: { xs: "12.5px", sm: "13px" },
                  color: "#3D3D52",
                  lineHeight: 1.7,
                  fontWeight: 400,
                  fontFamily: "var(--font-outfit)",
                }}
              >
                {item.text}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Product screenshot placeholder */}
        <Box
          sx={{
            overflow: "hidden",
          }}
        >
          <img
            src="https://getgeek-website-assets.b-cdn.net/ActuallyDoes.webp"
            alt="Zayn interview product preview"
            style={{ width: "100%", height: "auto", display: "block" }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default ZaynCapabilitiesSection;